import workspaceQuery from 'graphql/queries/system/SystemCompanyWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/system/SystemCompanyListQuery.graphql';
import instanceQuery from 'graphql/queries/system/SystemCompanyQuery.graphql';
import defaultQuery from 'graphql/queries/system/SystemCompanyDefault.graphql';
import createQuery from 'graphql/mutations/system/SystemCompanyCreateMutation.graphql';
import mutationQuery from 'graphql/mutations/system/SystemCompanyMutation.graphql';
import fragment from 'graphql/fragments/system/SystemCompanyFragment.graphql';

const SystemCompany = {
  type: 'SystemCompany',
  title: 'Company Databases',
  formTitle: 'Company Database',
  formUrl: '/System/Company/Details/',
  workspaceUrl: '/System/Company/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  create: createQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SYSTEM_COMPANY',
};

export default SystemCompany;
